import Vue from 'vue';
import Router from 'vue-router';
import store from './store';

Vue.use(Router);

const checkLicensePlate = async (to, from, next) => {
  if (to.params.guid !== undefined && store.state.appointment.licensePlate === '') {
    // console.log(to.params.guid);
    await store.dispatch('appointment/FETCH_DATA_CUSTOMER_TPP', to.params.guid);
  }

  if (store.state.appointment.licensePlate !== '') {
    next();
    return;
  }
  next('/');
};

const setLanguage = (to, from, next) => {
  if (to.name === 'fr') {
    Vue.config.language = 'fr_BE';
  } else {
    Vue.config.language = 'nl_BE';
  }
  next('/');
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/styleguide',
    name: 'styleguide',
    component: () => import('./views/Styleguide/Styleguide.vue'),
  },
  {
    path: '/nl',
    name: 'nl',
    beforeEnter: setLanguage,
    component: () => import('./views/Flow/Step1LicensePlate/Step1LicensePlate.vue'),
  },
  {
    path: '/fr',
    name: 'fr',
    beforeEnter: setLanguage,
    component: () => import('./views/Flow/Step1LicensePlate/Step1LicensePlate.vue'),
  },
  {
    path: '/',
    name: 'step1LicensePlate',
    component: () => import('./views/Flow/Step1LicensePlate/Step1LicensePlate.vue'),
  },
  {
    path: '/client/*',
    name: 'step1LicensePlateCompany',
    component: () => import('./views/Flow/Step1LicensePlateCompany/Step1LicensePlateCompany.vue'),
  },
  {
    path: '/mobile/:company',
    name: 'step1LicensePlateBussiness',
    component: () => import('./views/Flow/MobileBusiness/Step1LicensePlateBussiness/Step1LicensePlateBussiness.vue'),
  },
  {
    path: '/region',
    name: 'step1LicensePlateMobileRegion',
    component: () => import('./views/Flow/MobileRegion/Step1LicensePlateMobileRegion/Step1LicensePlateMobileRegion.vue'),
  },
  {
    path: '/vehicle-type',
    name: 'step2VehiculeType',
    component: () => import('./views/Flow/Step2VehiculeType/Step2VehiculeType.vue'),
    beforeEnter: checkLicensePlate,
  },
  {
    path: '/mobile/:company/vehicle-type',
    name: 'step2VehiculeTypeMobile',
    component: () => import('./views/Flow/MobileBusiness/Step2VehiculeTypeMobile/Step2VehiculeTypeMobile.vue'),
    beforeEnter: checkLicensePlate,
  },
  {
    path: '/region/vehicle-type',
    name: 'step2VehiculeTypeMobileRegion',
    component: () => import('./views/Flow/MobileRegion/Step2VehiculeTypeMobileRegion/Step2VehiculeTypeMobileRegion.vue'),
    beforeEnter: checkLicensePlate,
  },
  {
    path: '/service-type',
    name: 'step3ServiceType',
    component: () => import('./views/Flow/Step3ServiceType/Step3ServiceType.vue'),
    beforeEnter: checkLicensePlate,
  },
  {
    path: '/region/service-type',
    name: 'step3ServiceTypeMobileRegion',
    component: () => import('./views/Flow/MobileRegion/Step3ServiceTypeMobileRegion/Step3ServiceTypeMobileRegion.vue'),
    beforeEnter: checkLicensePlate,
  },
  {
    path: '/leasing-company',
    name: 'step4LeasingCompany',
    component: () => import('./views/Flow/Step4LeasingCompany/Step4LeasingCompany.vue'),
    beforeEnter: checkLicensePlate,
  },
  {
    path: '/mobile/:company/leasing-company',
    name: 'step4LeasingCompanyMobile',
    component: () => import('./views/Flow/MobileBusiness/Step4LeasingCompanyMobile/Step4LeasingCompanyMobile.vue'),
    beforeEnter: checkLicensePlate,
  },
  {
    path: '/region/leasing-company',
    name: 'step4LeasingCompanyMobileRegion',
    component: () => import('./views/Flow/MobileRegion/Step4LeasingCompanyMobileRegion/Step4LeasingCompanyMobileRegion.vue'),
    beforeEnter: checkLicensePlate,
  },
  {
    path: '/tire-info',
    name: 'step5TireInfo',
    component: () => import('./views/Flow/Step5TireInfo/Step5TireInfo.vue'),
    beforeEnter: checkLicensePlate,
  },
  {
    path: '/mobile/:company/tire-info',
    name: 'step5TireInfoMobile',
    component: () => import('./views/Flow/MobileBusiness/Step5TireInfoMobile/Step5TireInfoMobile.vue'),
    beforeEnter: checkLicensePlate,
  },
  {
    path: '/tpp/:guid',
    name: 'step5TireInfoMobileTTP',
    component: () => import('./views/Flow/MobileTTP/Step5TireInfoMobileTTP/Step5TireInfoMobileTTP.vue'),
    beforeEnter: checkLicensePlate,
  },
  {
    path: '/region/tire-info',
    name: 'step5TireInfoMobileRegion',
    component: () => import('./views/Flow/MobileRegion/Step5TireInfoMobileRegion/Step5TireInfoMobileRegion.vue'),
    beforeEnter: checkLicensePlate,
  },
  {
    path: '/appointment-info',
    name: 'step6AppointmentInfo',
    component: () => import('./views/Flow/Step6AppointmentInfo/Step6AppointmentInfo.vue'),
    beforeEnter: checkLicensePlate,
  },
  {
    path: '/mobile/:company/appointment-info',
    name: 'step6AppointmentInfoMobile',
    component: () => import('./views/Flow/MobileBusiness/Step6AppointmentInfoMobile/Step6AppointmentInfoMobile.vue'),
    beforeEnter: checkLicensePlate,
  },
  {
    path: '/tpp/:guid/appointment-info',
    name: 'step6AppointmentInfoMobileTPP',
    component: () => import('./views/Flow/MobileTTP/Step6AppointmentInfoMobileTPP/Step6AppointmentInfoMobileTPP.vue'),
    beforeEnter: checkLicensePlate,
  },
  {
    path: '/region/appointment-info',
    name: 'step6AppointmentInfoMobileRegion',
    component: () => import('./views/Flow/MobileRegion/Step6AppointmentInfoMobileRegion/Step6AppointmentInfoMobileRegion.vue'),
    beforeEnter: checkLicensePlate,
  },
  {
    path: '/confirmation',
    name: 'step7Confirmation',
    component: () => import('./views/Flow/Step7Confirmation/Step7Confirmation.vue'),
    beforeEnter: checkLicensePlate,
  },
  {
    path: '/go-to-webshop',
    name: 'goToWebshop',
    component: () => import('./views/GoToWebshop/GoToWebshop.vue'),
  },
  {
    path: '/alignment-info',
    name: 'alignmentInfo',
    component: () => import('./views/AlignmentInfo/AlignmentInfo.vue'),
  },
  {
    path: '/maintenance-info',
    name: 'maintenanceInfo',
    component: () => import('./views/Flow/Step1Maintenance/Step1Maintenance.vue'),
    beforeEnter: checkLicensePlate,
  },
  {
    path: '/contact-fleet-agent',
    name: 'contactFleetAgent',
    component: () => import('./views/ContactFleetAgent/ContactFleetAgent.vue'),
  },
  {
    path: '/error/no-maintenance-service-centers',
    name: 'noMaintenanceServiceCenters',
    component: () => import('./views/NoMaintenanceServiceCenters/NoMaintenanceServiceCenters.vue'),
  },
  {
    path: '/has-appointment-already',
    name: 'hasAppointment',
    component: () => import('./views/HasAppointment/HasAppointment.vue'),
  },
  {
    path: '/update-appointment',
    name: 'updateAppointment',
    component: () => import('./views/Flow/Step6AppointmentInfoUpdate/Step6AppointmentInfoUpdate.vue'),
  },
  {
    path: '/template',
    name: 'template',
    component: () => import('./views/Template/Template.vue'),
  },
  {
    path: '/components',
    name: 'components',
    component: () => import('./views/Components/Components.vue'),
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('./views/Error/Error.vue'),
  },
  {
    path: '*',
    name: '404',
    component: () => import('./views/Flow/Step1LicensePlate/Step1LicensePlate.vue'),
  },
  ],
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});
